export function parseCoolingTemperature(value) {
  const text = String(value ?? "").trim().replace(",", ".");
  if (!/^-?\d+(\.\d+)?$/.test(text)) return null;
  const number = Number(text);
  return Number.isFinite(number) && number >= -50 && number <= 150 ? number : null;
}
export function coolingStatus(record, now = Date.now()) {
  if (record.eind_tijd && record.eind_temp != null && record.eind_temp !== "") return "closed";
  const start = Date.parse(record.started_at);
  if (!Number.isFinite(start)) return "legacy";
  const elapsed = now - start;
  if (elapsed >= 5 * 3600000) return "final_due";
  if (elapsed >= 2 * 3600000 && !record.interim_at) return "interim_due";
  return "running";
}
export function coolingMinutes(record, now = Date.now()) {
  const start = Date.parse(record.started_at);
  return Number.isFinite(start) ? Math.max(0, Math.ceil((now - start) / 60000)) : null;
}
export function coolingDeviation(record, temperature, now = Date.now()) {
  const start = Date.parse(record.started_at);
  return !Number.isFinite(start) || temperature > 7 || now - start > 5 * 3600000;
}

export function activeCoolingItemIds(records, items) {
  const ids = new Set();
  const names = new Map();
  const normalize = value => String(value || "").trim().toLowerCase();
  for (const item of items.filter(i => !i.archived)) {
    const key = normalize(item.naam);
    names.set(key, [...(names.get(key) || []), item.id]);
  }
  for (const record of records) {
    if (!record.started_at || coolingStatus(record) === "closed") continue;
    if (record.source_mep_item_id) ids.add(String(record.source_mep_item_id));
    else {
      // Older sessions (including the first preview) only have a product name.
      // Never guess when multiple MEP items share that name.
      const matches = names.get(normalize(record.product)) || [];
      if (matches.length === 1) ids.add(String(matches[0]));
    }
  }
  return ids;
}
